import messageListLayoutStore from "../messageListLayoutStore";
import getLegacyPersonaCheckboxDisplay from "../../utils/getLegacyPersonaCheckboxDisplay";
import type { PersonaCheckboxDisplayOption } from "../schema/PersonaCheckboxDisplayOption";

// Fall back to the legacy HideSenderImage-derived value when it has not been initialized yet.
export default function getPersonaCheckboxDisplay(): PersonaCheckboxDisplayOption {
    const stored = messageListLayoutStore().personaCheckboxDisplay;
    return (stored as PersonaCheckboxDisplayOption | null) ?? getLegacyPersonaCheckboxDisplay();
}
